import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { AllocationViewDecoupleActionState } from './allocation-view-decouple-action.state';
import {
  AllocationViewDecoupleAction,
  AllocationViewDecoupleSetInitialState,
} from './allocation-view-decouple-action.actions';

@Injectable({ providedIn: 'root' })
export class AllocationViewDecoupleActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewDecoupleActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewDecoupleAction({
            identifier,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewDecoupleSetInitialState());
  }
}
